/**
 * Prototype on purpose to allow simple changes without chances of
 * breaking other sections messages
 *
 * @example var messages = new e.Messages();
            messages.display_message( 'class_restored' );
 *
 * @returns {{display_message: display_message, display_error: display_error}}
 */
e.Messages = function(){
	this.content_div = '#content';

	this.display_message = function( message_key ){
		$( '#message' ).remove();
		var $template = Handlebars.compile( config.templates.message );
		var $output = $template( {message : config.messages[message_key]} );
		$( this.content_div ).prepend( $output );
		$( "html, body" ).animate( {scrollTop : 0}, "slow" );
	};

	this.display_error = function( message_key ){
		$( '#message' ).remove();
		var $template = Handlebars.compile( config.templates.error_message );
		var $output = $template( {message : config.messages[message_key]} );
		$( this.content_div ).prepend( $output );
		$( "html, body" ).animate( {scrollTop : 0}, "slow" );
	}

};